module.exports = __webpack_public_path__ + "img/team-lissi-rob.a0e6fdfd.jpg";